var map = {
	"./data_composite": "7e22",
	"./data_composite.js": "7e22",
	"./data_registered": "0049",
	"./data_registered.js": "0049",
	"./data_unregistered": "e2c0",
	"./data_unregistered.js": "e2c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1644";